import { WORKEFFY_BASENAME } from './workeffy';

// Departments and org roles are managed in effy-fe's org structure now (see `redirects.js`).
const ORG_STRUCTURE_ROUTE = `${WORKEFFY_BASENAME}/admin/org-setup/manual`;

const departmentAdminRoutes = {
  DepartmentManager: () => ORG_STRUCTURE_ROUTE,
  DepartmentDetails: (_departmentId: string) => ORG_STRUCTURE_ROUTE,
  DepartmentEdit: (_departmentId: string) => ORG_STRUCTURE_ROUTE,
  DepartmentTrackDetails: (_departmentId: string) => ORG_STRUCTURE_ROUTE,
  RoleDetails: (_departmentId: string, _roleId: string) => ORG_STRUCTURE_ROUTE,
};

export default departmentAdminRoutes;
